var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Button, Card, Image, Link, Loader, Tag, Text, TextFontSize, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components/lib/components';
import { bool, eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ButtonTheme, Placement, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction, isMobileResolution } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import consultation from '../../assets/images/global/consultation.svg';
import avatarExamSchedule from '../../assets/images/avatars/avatar-exam-schedule.svg';
import avatarPhysician from '../../assets/images/avatars/avatar-phys.svg';
import avatarService from '../../assets/images/global/avatar-service.svg';
import CanceledSVG from '../../assets/images/icons/Canceled.svg';
import ConfirmedSVG from '../../assets/images/icons/Confirmed.svg';
import checkSVG from '../../assets/images/global/check-green.svg';
import InExecutionSVG from '../../assets/images/icons/In_execution.svg';
import RequestedSVG from '../../assets/images/icons/Requested.svg';
import LostSVG from '../../assets/images/icons/Lost.svg';
import { getPreferredTime, getStatusTextByIeStatus, getStatusTextByIeStatusListaEspera, getSubtitle, SCHEDULE_OTHER_STATUS, SCHEDULE_STATUS } from '../../util/card-util';
import CardAppointmentsAPI from './card-appointments-api';
import { func } from 'prop-types';
import moment from 'moment';
import './card-appointments.css';
import { AppointmentCardUtils } from '../../util/appointment-card-utils';
const SCHEDULE_TYPE = {
    CHEMOTHERAPY: 'Q',
    CONSULTATION: 'C',
    EXAM: 'E',
    REQUEST: 'R',
    SERVICE: 'S',
    SURGERY: 'Y',
};
const statusIconMap = new Map([
    ['10', checkSVG],
    ['15', CanceledSVG],
    ['20', LostSVG],
    ['25', InExecutionSVG],
    ['30', CanceledSVG],
    ['35', ConfirmedSVG],
    ['40', ConfirmedSVG],
    ['P', InExecutionSVG],
    ['X', CanceledSVG],
    ['R', RequestedSVG],
]);
let CardAppointments = class CardAppointments extends Component {
    constructor(props) {
        super(props);
        this.isProcessingCancellation = false;
        this.abortOnClickCard = false;
        this.isCancelled = false;
        this.state = {
            data: {},
            teleconsultationButtonDisabled: false,
            visible: true,
            width: 12,
        };
        this.setIsProcessingCancellation = (value) => {
            this.isProcessingCancellation = value;
            this.forceUpdate();
        };
        this.onClick = () => {
            if (this.isProcessingCancellation || this.abortOnClickCard) {
                this.abortOnClickCard = false;
                return;
            }
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({ value: { ...this.props } }));
            }
        };
        this.getIcon = (ieScheduleType) => {
            switch (ieScheduleType) {
                case SCHEDULE_TYPE.EXAM: return avatarExamSchedule;
                case SCHEDULE_TYPE.SERVICE: return avatarService;
                case SCHEDULE_TYPE.SURGERY:
                case SCHEDULE_TYPE.CHEMOTHERAPY: return avatarPhysician;
                default: return consultation;
            }
        };
        this.getCardRightContentWaitingList = (nrSequenceWaitingList) => {
            if (this.isProcessingCancellation) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(Loader, { size: 16, message: '' })));
            }
            const { statusWaitingList } = this.props;
            if (this.isCancelled || statusWaitingList === SCHEDULE_TYPE.CONSULTATION) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(Tag, { value: getStatusTextByIeStatusListaEspera(SCHEDULE_TYPE.CONSULTATION), formatters: {} })));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(Link, { value: MessageService.translate('patient.cancel'), onClick: () => this.removeFromWaitlistItem(nrSequenceWaitingList) })));
        };
    }
    static { this.propTypes = {
        cancelWaitlistItem: func,
        dsFotoBase64: string,
        dsStatus: string,
        dsSubTitulo: string,
        dsTitulo: string,
        dsTypeSchedule: string,
        dtAgendamento: string,
        hrAgendamento: string,
        ieScheduleType: string,
        ieScheduleTypeOrigin: string,
        ieStatus: string,
        nrSequencia: number,
        onAppointmentCancel: func,
        onAppointmentConfirm: func,
        onAppointmentReschedule: func,
        onAppointmentRescheduleMore: func,
        onClick: eventListener,
        onEnterTeleconsultation: func,
        onSelect: eventListener,
        patientId: number,
        rescheduleConsultation: string,
        rescheduleExam: string,
        rescheduleService: string,
        teleconsultationButtonDisabled: bool
    }; }
    handleMenuCardActionClick() {
        this.abortOnClickCard = true;
    }
    removeFromWaitlistItem(nrSequenceWaitingList) {
        this.setIsProcessingCancellation(true);
        const cancelWaitlistItem = this.props.cancelWaitlistItem;
        if (cancelWaitlistItem != null && nrSequenceWaitingList) {
            cancelWaitlistItem(nrSequenceWaitingList).then(() => this.isCancelled = true).finally(() => {
                this.isProcessingCancellation = false;
                this.forceUpdate();
            });
        }
    }
    onClickTeleconsultationButton() {
        this.abortOnClickCard = true;
        const { onEnterTeleconsultation, nrSequencia, ieScheduleType } = this.props;
        if (onEnterTeleconsultation != null) {
            onEnterTeleconsultation(Number(nrSequencia), ieScheduleType);
        }
    }
    renderTeleconsultationButton(status) {
        return (React.createElement("div", { className: 'teleconsultation-button' },
            React.createElement(Button, { onClick: () => this.onClickTeleconsultationButton(), value: '', size: Size.SMALL, icon: '/static/assets/icons/camera-available.svg', iconPlacement: Placement.LEFT, theme: ButtonTheme.PRIMARY, enabled: status })));
    }
    renderTeleconsultationField() {
        const { ieTelemedicina, ieStatus, dtAgendamento, teleconsultationButtonDisabled } = this.props;
        if (ieTelemedicina === 'S' && ((ieStatus === SCHEDULE_STATUS.APPROVED)
            || (ieStatus === SCHEDULE_STATUS.CONFIRMED) || (ieStatus === SCHEDULE_OTHER_STATUS.EXECUTION))) {
            const actualDate = moment().startOf('day');
            const dateDiffInDays = moment(dtAgendamento).diff(actualDate, 'days');
            if (dateDiffInDays === 0 && !teleconsultationButtonDisabled) {
                return this.renderTeleconsultationButton(true);
            }
            return this.renderTeleconsultationButton(false);
        }
        return React.createElement(React.Fragment, null);
    }
    render() {
        const { dsFotoBase64, dsTitulo, dsTypeSchedule, ieScheduleType, dsSubTitulo, hrAgendamento, ieStatus, selectable, selectionType = SelectionType.SINGLE, selected = false, nrSequenceWaitingList, onSelect } = this.props;
        const icon = this.getIcon(ieScheduleType);
        const avatarTitle = dsTitulo ?? '-';
        const iconStatus = statusIconMap.get(ieStatus) || '';
        return (React.createElement(Card, { className: 'card-appointments-schedule', onClick: () => this.onClick(), width: 12, selectable: selectable, selectionType: selectionType, selected: selected, uuid: generateUUID(), onSelect: onSelect },
            React.createElement("div", { className: 'card-appointments-schedule-container' },
                React.createElement("div", { className: 'card-avatar-data' },
                    React.createElement(Avatar, { hideImage: isMobileResolution(), image: dsFotoBase64 ? dsFotoBase64 : icon, title: avatarTitle, subtitle: getSubtitle([dsTypeSchedule, dsSubTitulo]) })),
                React.createElement("div", { className: "additional-data" },
                    this.renderTeleconsultationField(),
                    React.createElement(Text, { className: 'hour-scheduling', value: getPreferredTime(hrAgendamento), size: TextFontSize.SMALL, bold: true }),
                    React.createElement("div", { className: `content-status${nrSequenceWaitingList ? '--waitlist' : ''}` }, !nrSequenceWaitingList
                        ?
                            React.createElement(Tooltip, { triggers: [TooltipTrigger.HOVER], value: getStatusTextByIeStatus(ieStatus) },
                                React.createElement("div", null,
                                    React.createElement(Image, { src: iconStatus, alt: '', className: 'status-icon' })))
                        :
                            this.getCardRightContentWaitingList(nrSequenceWaitingList)),
                    React.createElement("div", { onClick: () => this.handleMenuCardActionClick() }, AppointmentCardUtils.getCardAction(this.props))))));
    }
};
CardAppointments = __decorate([
    AwesomeComponent({ api: CardAppointmentsAPI, type: ComponentType.DATA_DISPLAY }),
    __metadata("design:paramtypes", [Object])
], CardAppointments);
export default CardAppointments;
//# sourceMappingURL=card-appointments.js.map